const state = {
  // subscription_plan: {
  //   name: 'Go PRO',
  //   price: 19.9,
  //   description: 'Best for restaurants & local retailers',
  //   type: 'monthly', // monthly / yearly
  //   free_trial: false
  // }
}

const getters = {
  // getSubscriptionPlan (state) {
  //   return state.subscription_plan
  // },
  // getName (state) {
  //   return state.name
  // }
}

const mutations = {
  // setSubscriptionPlan (state, data) {
  //   console.log('inside mutatoin')
  //   state.subscription_plan = data
  // }
}

const actions = {
  // chooseSubscription (context, subscription) {
  //   console.log('Hello from actions')
  //   context.commit('setSubscriptionPlan', subscription)
  // }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
